import { Component} from '@angular/core';
import {
  AlertController, App, LoadingController, ModalController, NavController, NavParams,
  Platform,
  ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import { Storage } from '@ionic/storage';


@Component({
  selector: 'page-fees-details',
  templateUrl: 'fees-details.html',
})
export class FeesDetailsPage {

  FUserId:any;
  UserRights:any;
  StudentFormNo:any;
  StudentId:any;
  SchoolId:any;
  AcademicYear:any;
  FeesData:any;
  FAcademicYearId:any;
  FeesDetailsData:any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public service: ServiceProvider,
              public platform:Platform,
              public loadingCtrl: LoadingController,
              public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public modalCtrl: ModalController,
              public alertCtrl: AlertController,
              public viewCtrl: ViewController) {

    Promise.all([this.storage.get('LoginData'),this.storage.get('UserData')]).then(values => {
      console.log(values);
      this.FUserId = values[0]['FUserId'];
      this.FeesData = navParams.get('feesdata');
      this.StudentFormNo=this.FeesData.StudentFormNo;
      this.StudentId=this.FeesData.StudentId;
      this.SchoolId=this.FeesData.SchoolId;
      this.AcademicYear=this.FeesData.AcademicYear;
      this.FAcademicYearId=this.FeesData.FAcademicYearId;
      console.log("Data -> ",this.FeesData);
      this.loadValues(this.SchoolId,this.StudentId,this.FAcademicYearId);
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FeesDetailsPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  loadValues(SchoolId,StudentId,FAcademicYearId){
    this.service.httpcall('app_web_service/get_student_full_fees_details_school_Id?StudentId='+StudentId+'&SchoolId='+SchoolId+'&FAcademicYearId='+FAcademicYearId).subscribe(data => {
      console.log(data);
      if(data['response']=="success"){
        this.FeesDetailsData=data['Data'];
      }else{
        this.showAlert(data['error_description'],data['response']);
      }
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadValues(this.SchoolId,this.StudentId,this.FAcademicYearId);
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }

  showAlert(msg,title) {
    const alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['close']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/fees-details/fees-details.ts